/*******************************************************
 * Unclick tool
 *******************************************************/

module.exports = (function () {
    var Unclick = {},
        _unclicks = [],
        _exceptElems = [];

    function makeUnclickEvent(targ) {
        var unclickEvent = document.createEvent('CustomEvent');
        unclickEvent.initEvent('unclick', true, true, {
            target: targ
        });
        return unclickEvent;
    }

    function checkUnclick(targ) {
        _unclicks.forEach(function (_elem) {
            if (targ !== _elem) {
                if (!isDescendant(_elem, targ) && !isInExceptElements(_elem, targ)) {
                    _elem.dispatchEvent(makeUnclickEvent(_elem));
                }
            }
        });
    }

    function isDescendant(parent, child) {
        var node = child.parentNode;
        while (node != null) {
            if (node == parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    }

    function isInExceptElements(elem, targ) {
        for (var i = 0; i < _exceptElems.length; i++) {
            if (elem == _exceptElems[i].elem) {
                for (var j = 0; j < _exceptElems[i].excepts.length; j++) {
                    if (targ == _exceptElems[i].excepts[j] || $(_exceptElems[i].excepts[j]).find(targ).length > 0) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    window.addEventListener('click', function (e) {
        checkUnclick(e.target);
    });

    Unclick.registerUnclick = function (element, cb, exceptElems) {
        _unclicks.push(element);

        for (var i = 0; exceptElems && i < exceptElems.length; i++) {
            _exceptElems.push(exceptElems[i]);
        }

        element.addEventListener('unclick', cb);
    };

    return Unclick;
})();